module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 11
// module chunks = 0 1 2 3